import type { ColumnPattern } from "@/common/components/Table";

export const moveActionsColumnFirst = (
  columns: ColumnPattern[]
): ColumnPattern[] => {
  const actionsIndex = columns.findIndex(
    (column) => column.value === "actions" || column.value === "action"
  );

  if (actionsIndex <= 0) {
    return columns;
  }

  const reorderedColumns = [...columns];
  const [actionsColumn] = reorderedColumns.splice(actionsIndex, 1);

  return [actionsColumn, ...reorderedColumns];
};
